import React from "react";
import { Input } from "@/components/ui/input";
import { WhatsAppQuickMenu } from "@/components/WhatsAppQuickMenu";
import { validateItalianMobile } from "@/lib/api";

/**
 * 🆕 Feb 2026 — Componente unificato per input Cellulare in tutta l'app.
 * Replica esattamente la logica del campo Cellulare in Clients.jsx:
 *  - Validazione live via validateItalianMobile
 *  - Bordo/sfondo verde se valido, rosso se invalido
 *  - Pulsante WhatsApp (WhatsAppQuickMenu) inline a destra quando il numero è presente
 *  - Messaggio "✓ Numero valido" o errore sotto l'input
 *
 * Props:
 *  - value: valore attuale (string)
 *  - onChange: (nuovo_value: string) => void — riceve già il valore senza spazi
 *  - onBlur?: (nuovo_value: string) => void
 *  - placeholder?: string
 *  - testid?: string — usato come base per data-testid dell'input e del bottone WA
 *  - clientName?: string — nome cliente da precompilare nel messaggio WA
 *  - waCategory?: string — categoria WA opzionale
 *  - disabled?: bool
 *  - showWaButton?: bool (default true) — se false nasconde il pulsante WhatsApp
 *  - className?: string — classi extra sul wrapper Input
 */
const MobileInputWithWA = ({
  value,
  onChange,
  onBlur,
  placeholder = "Es. 3331234567 oppure +393331234567",
  testid = "mobile-input",
  clientName = "",
  waCategory,
  disabled = false,
  showWaButton = true,
  className = "",
}) => {
  const raw = value || "";
  const mv = raw.trim() ? validateItalianMobile(raw) : null;
  const invalid = mv && !mv.ok;
  const valid = mv && mv.ok;

  const handleChange = (e) => {
    onChange?.(e.target.value.replace(/\s+/g, ""));
  };
  const handleBlur = (e) => {
    onBlur?.(e.target.value.replace(/\s+/g, ""));
  };

  return (
    <>
      <div className="flex gap-1.5">
        <Input
          data-testid={testid}
          value={raw}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={placeholder}
          disabled={disabled}
          className={`${invalid ? "border-rose-500 bg-rose-50/30" : valid ? "border-emerald-500 bg-emerald-50/30" : ""} ${className}`.trim()}
        />
        {showWaButton && raw.trim() && (
          <WhatsAppQuickMenu
            number={raw}
            clientName={clientName}
            testid={`${testid}-wa`}
          />
        )}
      </div>
      {invalid && <span className="text-[10px] text-rose-600 mt-0.5 block">{mv.message}</span>}
      {valid && <span className="text-[10px] text-emerald-700 mt-0.5 block">✓ Numero valido</span>}
    </>
  );
};

export default MobileInputWithWA;
export { MobileInputWithWA };
